import Footer from "./../../Footer";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {isCart, useUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import ShoppingCart from "../../cart/ShoppingCart/ShoppingCart";
import Modal from "./Modal";
import styles from "./CartWrapperModal.module.scss";
import EmptyCartScreen from "../../cart/ShoppingCart/EmptyCart";
import {ClickOriginType} from "../../cart/CartIcon/CartIconPortal";

interface ICartWrapperProps {
  isCartVisible: boolean;
  closeFunction: (origin: ClickOriginType) => void;
}

const CartWrapperModal: React.FC<ICartWrapperProps> = (props) => {
  const context = useUnsafeCartContext();
  const {t} = useTranslation();

  if (!context) {
    return null;
  }

  const Header: React.FC = () => {
    const onLogoClicked = () => {
      if (isCart(context)) {
        context.setIsIntoCheckout(false);
      }
      props.closeFunction("logoClicked");
    };

    return (
      <header role="banner">
        <div className={styles.header}>
          <button
            type="button"
            className={`${styles.logo} icon icon-connox-logo`}
            onClick={onLogoClicked}
            aria-label={t("general.backHome")}
          />
          <div className={styles.secureOrder}>
            <i className={"icon icon-lock icon-size--18"} />
            <span>&#160;{t("cart.secureConnection")}</span>
          </div>
        </div>
        {isCart(context) && !context.isIntoCheckout && (
          <div>
            <button
              type="button"
              className={styles.backButton}
              onClick={() => {
                props.closeFunction("continueShopping");

                return false;
              }}
            >
              <i className={"icon icon-size--24 icon-left--blue"} />
              <span>{t("cart.continueShopping")}</span>
            </button>
          </div>
        )}
      </header>
    );
  };

  return (
    <Modal fullScreen={true} isVisible={context.isCartVisible} modalTitle={t("checkout.yourCart")}>
      <Header />
      <main className={styles.wrapper}>{isCart(context) ? <ShoppingCart /> : <EmptyCartScreen />}</main>
      <Footer />
    </Modal>
  );
};

export default CartWrapperModal;
